import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import HubsEntityCollection from '../../../../../components/HubsEntityCollection';
import HubsSelectField from '../../../../../components/HubsSelectField';

export const EntityComponent = ({ entity, handleChange, order, collection }) => {
  const entityData = collection.editor.getEntity(entity.eid, 'he_admissionfactortype');
  return (
    <React.Fragment>
      <HubsSelectField
        selection
        name="Importance"
        field={entityData.getField('he_importance')}
        initialValue={entity.importance}
        onChange={(e, value) => handleChange(e, {
          value: value.value,
          order,
          name: 'importance',
          field_he_admissionfactortype: get(collection, 'editor.cmsDataMapping.applicationFactorMetaData.field_he_admissionfactortype.allowed_values', {})[entity.type],
          field_he_importance: get(collection, 'editor.cmsDataMapping.applicationFactorMetaData.field_he_importance.allowed_values', {})[value.value],
        }, null, order)}
      />
    </React.Fragment>
  );
};

EntityComponent.propTypes = {
  entity: PropTypes.object,
  handleChange: PropTypes.func,
  order: PropTypes.number,
  collection: PropTypes.object,
};

const ApplicationFactors = ({ onChange, ...props }) => (
  <HubsEntityCollection
    {...props}
    disableRemove
    nonUnique
    _key="he_admissionfactortype"
  >
    <EntityComponent handleChange={onChange} />
  </HubsEntityCollection>
);

ApplicationFactors.propTypes = {
  initialValue: PropTypes.array,
  onChange: PropTypes.func,
  mapper: PropTypes.object,
};

export default ApplicationFactors;
